import { useEffect, useState } from "react";
import api from "../lib/api";
import CompetitionCard from "../components/CompetitionCard";
import SEO from "../components/SEO";

export default function BestValue() {
  const [comps, setComps] = useState([]);
  useEffect(() => {
    api.get("/competitions", { params: { sort: "value", limit: 200 } }).then((r) => setComps(r.data));
  }, []);

  const top = comps.slice(0, 24);
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
      <SEO
        title="Best value UK prize competitions"
        description="UK prize competitions ranked by expected value per ticket. See odds, CompCheck Score and free-entry clarity before you enter."
        path="/best-value"
        ogType="website"
      />
      <div className="mb-10 max-w-2xl">
        <div className="overline text-[var(--cc-gold)] mb-2">Best value</div>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold">UK competitions ranked by value</h1>
        <p className="text-[var(--cc-text-muted)] mt-3 leading-relaxed">
          We rank competitions by expected value per ticket across the full ticket
          pool. Higher means each pound of ticket buys you more of the prize, on paper.
          Always check the operator's terms and consider the free-entry route.
        </p>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {top.map((c, i) => <CompetitionCard key={c.id} comp={c} index={i} />)}
      </div>
    </div>
  );
}
